<style lang="stylus" scoped>
    html.dark
        .mini-map
            .mini-map-container
                border-radius 8px;
                border: 1px solid var(--color-black-12);
                .image-container
                    width 240px;
                    margin: -1px 0 0 -1px;
    .mini-map
        position relative
        display flex
        justify-content center
        align-items center
        margin-right 12px
        .layer-icon
            floatTool_icon()
            width 24px
            height 24px
            margin 0
            svg
                color: var(--svg-color-primary);
                &.active
                    color: var(--svg-color-active)


        .mini-map-container
            position absolute
            display flex
            justify-content center
            align-items center
            left 0
            top -186px
            width 240px
            height 168px
            border-radius 4px
            background-color var(--bg-color-mini-map-container)
            box-shadow $box-shadow
            overflow hidden
            transition left 0.5s
            .image-container
                position relative
                max-width 240px
                max-height 168px
                img
                    max-width 240px
                    max-height 168px
                .view-box
                    position absolute
                    border 2px solid #666
        .move-left
            left -390px
    .floattrans-enter-active, .floattrans-leave-active
        transition opacity .3s
    .floattrans-enter, .floattrans-leave-to
        opacity 0
</style>

<template>
    <div class="mini-map">
        <div ref="iconDom" class="layer-icon" v-tippy :content="showMiniMap ? $t('unpinMap') : $t('pinMap')" @click="toggleShow()" id="mini-map-icon">
            <iconSymbol :name="showMiniMap ? 'mini-map-active' : 'mini-map'" :class="showMiniMap ? 'active' : ''"></iconSymbol>
        </div>
        <transition name="floattrans">
            <div
                v-show="showMiniMap"
                class="mini-map-container"
                :class="{ 'move-left': showAIPanel }"
                @mousemove.stop="boxMousemoveHandler"
                @mousedown.stop="boxMousedownHandler"
                @wheel.stop="boxWheel"
            >
                <div ref="imageContainerRef" class="image-container">
                    <img id="miniMapPreviewImage" :src="previewUrl" alt="" draggable="false" />
                    <div
                        ref="miniMapViewBoxRef"
                        id="miniMapViewBox"
                        class="view-box"
                        :style="{
                            left: `${boxLeft}px`,
                            top: `${boxTop}px`,
                            width: `${boxWidth}px`,
                            height: `${boxHeight}px`,
                        }"
                    ></div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script lang="ts">
    /**
     * @file 迷你地图
     * @author luokq
     */

    import { Component, Vue, Watch } from "vue-property-decorator";
    import { throttle } from "lodash";
    declare var egSize: any;
    declare var egPoint: any;
    declare var UnitUtil: any;
    declare var EDView: any;

    @Component({})
    export default class MiniMap extends Vue {
        showMiniMap = false;

        get showAIPanel() {
            return this.$store.state.ui.showAIPanel;
        }

        toggleShow() {
            this.showMiniMap = !this.showMiniMap;
            this.$bus.$emit("showMiniMap", this.showMiniMap);
            this.renderPreview();

            this.sensors.track("Map", {
                Catalogues: "BottomToolbar",
            });
        }

        previewUrl = "";
        renderPreview = throttle(function () {
            if (!this.showMiniMap) {
                return;
            }

            const page = window["_view"].activePage();
            if (page) {
                page.toBitmap(
                    (blob) => {
                        this.previewUrl = URL.createObjectURL(blob);
                        this.setViewBoxStyle();
                    },
                    new egSize(240),
                    true
                );
            }
        }, 1000);

        boxLeft = 0;
        boxTop = 0;
        boxWidth = 100;
        boxHeight = 100;
        setViewBoxStyle = throttle(function () {
            if (!this.showMiniMap) {
                return;
            }

            const view = window["_view"];
            const page = window["_view"].activePage();
            if (!view || !page) {
                return;
            }

            const contentWidth = 240;
            const contentHeight = 168;
            const contentAspectRatio = contentWidth / contentHeight;

            const pageZoom = page.zoomFactor();
            const pageWidth = page.width * pageZoom;
            const pageHeight = page.height * pageZoom;
            const pageAspectRatio = pageWidth / pageHeight;
            const boxZoom = contentAspectRatio <= pageAspectRatio ? contentWidth / pageWidth : contentHeight / pageHeight;

            const { width: viewWidth, height: viewHeight } = view.viewSize();
            const { x, y } = view.viewToPage(new egPoint());

            this.boxWidth = (viewWidth * boxZoom) / UnitUtil.pixelRatio();
            this.boxHeight = (viewHeight * boxZoom) / UnitUtil.pixelRatio();
            this.boxLeft = x * pageZoom * boxZoom;
            this.boxTop = y * pageZoom * boxZoom;
        }, 34);

        get pageZoom() {
            return this.$store.state.ui.zoomValue;
        }

        @Watch("pageZoom")
        pageZoomChange() {
            this.setViewBoxStyle();
        }

        boxHandlerFn = throttle(function (e: MouseEvent) {
            const view = window["_view"];
            const page = window["_view"].activePage();
            const imageContainerRef = this.$refs.imageContainerRef as HTMLDivElement;
            const miniMapViewBoxRef = this.$refs.miniMapViewBoxRef as HTMLDivElement;
            if (!view || !page || !imageContainerRef || !miniMapViewBoxRef) {
                return;
            }

            let x = 0,
                y = 0;

            // x，y 为相对缩略图左上角的位置，根据点击（或移动停止）区域的不同进行计算
            if ((e.target as HTMLElement).id === "miniMapViewBox") {
                // 点击视图框内
                x = e.offsetX + miniMapViewBoxRef.offsetLeft;
                y = e.offsetY + miniMapViewBoxRef.offsetTop;
            } else if ((e.target as HTMLElement).id === "miniMapPreviewImage") {
                // 点击视框框外，且在缩略图内
                x = e.offsetX;
                y = e.offsetY;
            } else {
                // 点击范围在缩略图之外
                x = e.offsetX - imageContainerRef.offsetLeft;
                y = e.offsetY - imageContainerRef.offsetTop;
            }

            // x, y 要乘以 page 对 缩略图 的比例
            const scale = page.width / imageContainerRef.offsetWidth;
            x = x * scale;
            y = y * scale;

            page.scrollToPt(new egPoint(x, y));
        }, 34);

        boxMousemoveHandler(e: MouseEvent) {
            if (e.buttons === 1) {
                this.boxHandlerFn(e);
            }
        }

        boxMousedownHandler(e: MouseEvent) {
            this.boxHandlerFn(e);
        }

        boxWheel(e: WheelEvent) {
            const view = window["_view"];
            const page = window["_view"].activePage();

            if (!view || !page) {
                return;
            }

            // 步长为当前缩放比的 30%
            let step = page.zoomFactor() * 0.3;
            if (step < 0.05) {
                step = 0.05;
            } else if (step > 1) {
                step = 1;
            }

            view.hiddenFloatTool(true);
            if (view._tool.isToolOperating()) {
                return;
            }

            const smoothStep = EDView.osInfo.platform === "Mac" ? step / 2 : step;
            if (e.deltaY > 0) {
                view.zoomDown(smoothStep, false);
            } else {
                view.zoomUp(smoothStep, false);
            }
            view.expandFloatTool();
        }

        secneEvent() {
            this.setViewBoxStyle();
        }

        updatePreview() {
            this.$nextTick(() => {
                this.renderPreview();
            });
        }

        mounted() {
            this.$bus.$on("updateMiniMapPreview", this.updatePreview);

            window.addEventListener("resize", this.secneEvent);
            document.getElementById("scene").addEventListener("scroll", this.secneEvent);
        }

        beforeDestroy() {
            this.$bus.$off("updateMiniMapPreview", this.updatePreview);
            window.removeEventListener("resize", this.secneEvent);
            document.getElementById("scene").removeEventListener("scroll", this.secneEvent);
        }
    }
</script>

<i18n>
{
    "zh": {
        "pinMap": "打开地图",
        "unpinMap": "关闭地图"
    },
    "en": {
        "pinMap": "Pin Map",
        "unpinMap": "Unpin Map"
    },
    "fr": {
        "pinMap": "Ouvrir la carte",
        "unpinMap": "Fermer la carte"
    },
    "de": {
        "pinMap": "Karte öffnen",
        "unpinMap": "Karte schließen"
    },
    "jp": {
        "pinMap": "マップを開く",
        "unpinMap": "マップを閉じる"
    },
    "es": {
        "pinMap": "Abrir mapa",
        "unpinMap": "Cerrar mapa"
    },
    "pt": {
        "pinMap": "Abrir mapa",
        "unpinMap": "Fechar mapa"
    },
    "it": {
        "pinMap": "Apri mappa",
        "unpinMap": "Chiudi mappa"
    },
    "tw": {
        "pinMap": "開啟地圖",
        "unpinMap": "關閉地圖"
    },
    "kr": {
        "pinMap": "지도 열기",
        "unpinMap": "지도 닫기"
    }
}
</i18n>
